import { FormStore } from "./form-store";
import React, { useState } from "react";
import { BookedFormContent } from "./booked-form-content";
import { SkippingFormContent } from "./skipping-form-content";
import { SuspendFormContent } from "./suspend-form-content";
import "styled-components/macro";
import { FormBase } from "./form-base";
import { Drawer, Spinner } from "@blueprintjs/core";

import {
  useHideForm,
  useRaPayload,
  useVfPayload
} from "../../store/model-misc";
import { DRAWER_WIDTH } from "../../styles/constants";
import { hashFlopption } from "../../store/model-action-reports";

export function ReportActionModalWrapper() {
  const isOpen = useIsReportActionFormOpen();
  return isOpen && <ReportActionView />;
}

export function useIsFlopptions() {
  return !!useVfPayload();
}

export function useIsDeadFlopptions() {
  return useVfPayload()?.snapshot?.trip_dead !== undefined;
}

export function useActionName() {
  const { actionName } = useRaPayload2();
  return actionName;
}

export function useRaPayload2() {
  const ra_payload = useRaPayload();
  if (ra_payload === null) {
    return { opportunityData: null, actionName: null, key: null };
  } else {
    const opportunityData = ra_payload.snapshot;
    const actionName = ra_payload.actionName;
    const key = actionName + "|" + hashFlopption(opportunityData);
    return { opportunityData, actionName, key };
  }
}

export function useFormTitle() {
  const actionName = useActionName();
  if (actionName === "booked") {
    return "Tell us more about your booking";
  } else if (actionName === "skipping") {
    return "How can we do better?";
  } else if (actionName === "suspend") {
    return "In what scenario will you end up booking?";
  } else {
    console.error(`In useFormTitle -- Unknown actionName=${actionName}`);
    return "";
  }
}

export function useIsReportActionFormOpen() {
  return !!useRaPayload();
}

export function useFormStore() {
  const { key } = useRaPayload2();
  let formActions = FormStore.useStoreActions(a => a[key], [key]);
  let formState = FormStore.useStoreState(s => s[key], [key]);
  return [formState, formActions];
}

function MyFormStoreProvider({ children }) {
  const { opportunityData, actionName, key } = useRaPayload2();
  const isFlopptions = useIsFlopptions();
  return (
    <FormStore.Provider
      initialData={{
        key,
        actionName,
        opportunityData,
        isFlopptions
      }}
    >
      {children}
    </FormStore.Provider>
  );
}

function ReportActionFormContent() {
  const rehydrated = FormStore.useStoreRehydrated();
  return rehydrated ? <ModalContentInner /> : <Spinner />;
}

function ModalContentInner() {
  const actionName = useActionName();
  const [formState, formActions] = useFormStore();
  const [activeField, setActiveField] = useState(null);

  let formContent;
  if (actionName === "booked") {
    formContent = (
      <BookedFormContent
        formState={formState}
        formActions={formActions}
        activeField={activeField}
        setActiveField={setActiveField}
      />
    );
  } else if (actionName === "skipping") {
    formContent = (
      <SkippingFormContent
        formState={formState}
        formActions={formActions}
        activeField={activeField}
        setActiveField={setActiveField}
      />
    );
  } else if (actionName === "suspend") {
    formContent = (
      <SuspendFormContent
        formState={formState}
        formActions={formActions}
        activeField={activeField}
        setActiveField={setActiveField}
      />
    );
  }
  return (
    <FormBase formState={formState} formActions={formActions}>
      {formContent}
    </FormBase>
  );
}

function ReportActionDrawer() {
  return (
    <Drawer
      canEscapeKeyClose={false}
      isCloseButtonShown={true}
      isOpen={useIsReportActionFormOpen()}
      onClose={useHideForm()}
      className="bp3-dark"
      size={DRAWER_WIDTH}
      title={useFormTitle()}
    >
      <div
        css={`
          padding: 24px;
          overflow-y: auto;
        `}
      >
        <MyFormStoreProvider>
          <ReportActionFormContent />
        </MyFormStoreProvider>
      </div>
    </Drawer>
  );
}

export const ReportActionView = ReportActionDrawer;
